module.exports = __webpack_public_path__ + "media/icons-lj-styleguide-2025/x-208749c6.svg";